<template>
    <v-layout row wrap class="bulk-upload">
        <v-flex xs12 class="bulk-steps">
            {{assetSummaryConstants.BULK_UPLOAD_STEP1}}
            <a data-qe-id="downloadBulkAddTemplate" @click="downloadTemplate()">here</a>
        </v-flex>
        <v-flex xs12 class="bulk-steps" v-html="assetSummaryConstants.BULK_UPLOAD_STEP2"></v-flex>
        <v-flex xs12 class="bulk-steps">
            {{assetSummaryConstants.BULK_UPLOAD_STEP3}}
            <input type="file"
                id="file_upload"
                data-qe-id="file_upload_link"
                @change="onFileChange"
                class="file-upload"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            <label for="file_upload"><u>Upload</u></label>
        </v-flex>
        <v-flex xs12 class="bulk-steps" v-html="assetSummaryConstants.BULK_UPLOAD_STEP4"></v-flex>
        <v-flex xs12 class="bulk-steps" v-html="assetSummaryConstants.BULK_UPLOAD_STEP5"></v-flex>
        <confirmation-dialog
            v-model="showWarningMessage"
            typeOfDialog="alert"
            :title="assetSummaryConstants.INVALID_DOCUMENT"
            :message="assetSummaryConstants.UPLOAD_WARNING"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
        <confirmation-dialog
            v-model="showSuccessMessage"
            typeOfDialog="alert"
            :title="assetSummaryConstants.UPLOAD_SUCCESS_TITLE"
            :message="assetSummaryConstants.UPLOAD_SUCCESS_MESSAGE"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
    </v-layout>
</template>

<script>
    import { assetSummaryConstants } from './memberProfile.constants';
    import { mapActions, mapGetters } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeGetters } from '../../store/storeGetters.constant';
    import ConfirmationDialog from './EditDialogues/ConfirmationDialog';
    import FileUpload from "vue-upload-component";

    export default {
        name: 'BulkUpload',
        data: () => ({
            assetSummaryConstants,
            templateurl: '',
            files: [],
            showWarningMessage: false,
            showSuccessMessage: false,
        }),
        components: {
            ConfirmationDialog,
            FileUpload,
        },
        mounted() {
            this.templateurl = this.userProfile && this.userProfile.blobStorageUri
                ? `${this.userProfile.blobStorageUri}${this.assetSummaryConstants.BULK_UPLOAD_FRAGMENT}`
                : `${this.assetSummaryConstants.BULK_UPLOAD_FALLBACK_URL}${this.assetSummaryConstants.BULK_UPLOAD_FRAGMENT}`;
        },
        methods: {
            ...mapActions({
                uploadBulkAddFile: `memberProfile/${storeAction.uploadBulkAddFile}`,
                downloadBulkAddTemplate: `memberProfile/${storeAction.downloadBulkAddTemplate}`,
            }),
            onFileChange(e) {
                if (e.target.files && e.target.files.length <= 1) {
                    this.files = e.target.files;
                    const filename = this.files[0].name;
                    // validating the excel files
                    if (!/\.(xlx|xlsx)$/i.test(filename)) {
                        this.showWarningMessage = true;
                        e.target.value = "";
                    } else {
                        const formData = new FormData();
                        formData.append(`Files[${0}]`, this.files[0]);
                        this.uploadBulkAddFile(formData).then((res) => {
                            if (res && res.data) {
                                this.showSuccessMessage = true;
                            }
                            e.target.value = "";
                        });
                    }
                }
            },
            downloadTemplate() {
                this.downloadBulkAddTemplate(this.templateurl);
            },
        },
        computed: {
            ...mapGetters({
                userProfile: `memberProfile/${storeGetters.userProfile}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .bulk-upload {
        h2{
            margin: 20px 0px 0 3px;
        }
        .manage-asset-details {
            color: $ypo-cta;
            font-size: 14px;
            margin: 20px 10px;
            display: inline-block;
            cursor: pointer;
            font-weight: 600;
            &:hover {
                color: $ypo-blue;
            }
            @include breakpoint(xs) {
                position: relative;
                right: 0;
            }
        }
        .bulk-steps{
            padding: 20px;
            margin-bottom: 20px;
            color: $white;
            font-family: "Raleway", sans-serif;
            font-size: 14px;
            background: $ypo-blue;
            font-weight: 500;

            u {
                cursor: pointer;
            }

            a {
                color: $white !important;
                text-decoration: underline;
            }

            .file-upload {
                display: none;
            }
        }
    }
</style>
